export default __webpack_public_path__ + "static/media/spotify.be9eb909.svg";